import { useTheme } from '@mui/material/styles';
import { LinearGradient } from 'src/components/gradients/LinearGradient';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';
import { useEffect } from 'react';

export function useLinearGradient(gradientColor?: string) /*: string*/ {
  const theme = useTheme();
  const extractGradient = () => {
    if (!gradientColor) {
      return theme.palette.primary.vertical;
    }
    if (!gradientColor.includes('linear-gradient')) {
      const [section, gradient] = gradientColor.split('.');
      return theme.palette[`${section}`][`${gradient}`];
    } else {
      return gradientColor;
    }
  };
  const gradient = extractGradient();
  const id = gradient
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll(' ', '')
    .replaceAll(',', '')
    .replaceAll('#', '')
    .replaceAll('%', '');

  const { union } = useGlobalComponentsContext();

  useEffect(() => {
    union(gradient, <LinearGradient id={id} gradient={gradient} />);
  }, [gradient, id, union]);

  return id;
}
